import { SetStateAction, useEffect, useState } from "react";
import { Modal, Checkbox, Button, Alert } from "antd";
import { forEach } from "lodash";

const opciones = [
  { label: "Descargar actas con teléfono", value: 1 },
  { label: "Descargar actas con email", value: 2 },
  { label: "Descargar actas impagas", value: 3 },
  { label: "Descargar actas con dirección postal dudosa (S/N, SIN DIRECCION)", value: 4 },
  { label: "Descargar actas con dirección postal correcta", value: 5 },
  { label: "Solo EMPRESAS", value: 6 },
  { label: "No enviadas por correo electrónico", value: 7 },
];

const ModalElegirDescarga = (props: any) => {
  useEffect(() => {if (props.isOpen) { setSeleccionadas([]); setFrase(''); setLoading(false); setIncluirListaImpresor(false); setIncluirPdf(false) }}, [props.isOpen]);
  const [seleccionadas, setSeleccionadas] = useState([]);
  const [frase, setFrase] = useState('');
  const [loading, setLoading] = useState(false);
  const [incluirListaImpresor, setIncluirListaImpresor] = useState(false);
  const [incluirPdf, setIncluirPdf] = useState(false);

  const handleChange = (values: any) => {
    setSeleccionadas(values);
    setFrase('');
  
    if (values.length > 0) {
      let preFrase = 'Está por descargar actas que tienen ';
      let detalle: string[] = [];
  
      values.forEach((seleccion: number) => {
        if (seleccion === 1) detalle.push('nro de teléfono');
        if (seleccion === 2) detalle.push('correo electrónico');
        if (seleccion === 3) detalle.push('estado impagas');
        if (seleccion === 4) detalle.push('la dirección postal dudosa o sin información');
        if (seleccion === 5) detalle.push('la dirección postal correcta');
        if (seleccion === 6) detalle.push('ser empresas');
        if (seleccion === 7) detalle.push('no enviadas por correo electrónico');
      });
  
      preFrase += detalle.join(' y ');
      setFrase(preFrase);
    }
  };

  return (
    <Modal
      width={"30%"}
      footer={null}
      open={props.isOpen}
      onCancel={props.onCancel}
      destroyOnClose
      title='Elige las opciones de descarga'
    >
      <Checkbox.Group options={opciones} onChange={handleChange} style={{ display: "flex", flexDirection: "column", marginTop: "1em" }}/>
      <hr />
      <div>
          <Checkbox
            checked={incluirListaImpresor}
            onChange={(e) => setIncluirListaImpresor(e.target.checked)}
          >
            Incluir lista impresor (csv)
          </Checkbox>
          <Checkbox
            checked={incluirPdf}
            onChange={(e) => setIncluirPdf(e.target.checked)}
            style={{ marginLeft: 10 }}
          >
            Incluir PDF
          </Checkbox>
        </div>
      <div style={{ marginTop: 20, textAlign: "right" }}>
        <Button type="primary" onClick={() => {props.onClick(seleccionadas, incluirListaImpresor, incluirPdf); setLoading(true)}} disabled={seleccionadas.length === 0} loading={loading}>
          Descargar
        </Button>
      </div>
      {frase && (
        <Alert message={frase} type="info" showIcon style={{ marginTop: 10 }} />
      )}
    </Modal>
  );
};

export default ModalElegirDescarga;
